module.exports = __webpack_public_path__ + "img/Document_1__Shipbuilding_986_33_1.3e6fa2b9.jpg";